'use strict';
/* jshint ignore:start */
var emailsignup = {

	emailSignupEvent: function (e, data) {
		var obj = {
			button_ID: e.target.id ? e.target.id : e.target.innerText,
			customer_contact_preferences: getContactPreferences(data) || 'Hotel Chocolat',
			customer_contact_settings: 'email',
			email_reg_success: 'success',
			re_3rd_party_permit: 'yes',
			re_email_address: data[0]['dwfrm_emailsignup_email'].value,
			re_email_permit: 'yes',
			re_first_name: data[0]['dwfrm_emailsignup_nickname'].value,
			'event': 'emailSignup'
		};
		dataLayer.push(obj);
	},

	guestCheckoutEmailSignup: function (e) {
		var request3rdParty = $('input[name$=_contactPreferencesAllowMailshot]').prop('checked');
		var requestEmail = $('input[name$=_contactPreferencesAllowMail]').prop('checked');
		if (request3rdParty || requestEmail) {
			var obj = {
				button_ID: e.target.id ? e.target.id : e.target.innerText,
				customer_contact_preferences: '',
				customer_contact_settings: getContactSettings(),
				email_reg_success: 'success',
				re_3rd_party_permit: request3rdParty === true ? 'yes' : 'no',
				re_email_address: $('input[name$=_email]').val(),
				re_email_permit: requestEmail === true ? 'yes' : 'no',
				re_first_name: $('input[name$=_firstName]').val(),
				'event': 'emailSignup'
			};
			dataLayer.push(obj);
		}
	}
}
/**
 * @description Returns concatenated string of checked filter values from  section
 */
function getContactPreferences(data) {

	var preferences = '';
	if ($(data[0]['dwfrm_emailsignup_hotelchocolat']).prop('checked')) {
		var label = $("label[for='" + $(data[0]['dwfrm_emailsignup_hotelchocolat']).attr('id') + "']");
		if (preferences === '') {
			preferences =  label.text().trim();
		} else {
			preferences += ' | ' + label.text().trim();
		}
	}

	if ($(data[0]['dwfrm_emailsignup_restaurants']).prop('checked')) {
		var label = $("label[for='" + $(data[0]['dwfrm_emailsignup_restaurants']).attr('id') + "']");
		if (preferences === '') {
			preferences =  label.text().trim();
		} else {
			preferences += ' | ' + label.text().trim();
		}

	}

	if ($(data[0]['dwfrm_emailsignup_tastingclub']).prop('checked')) {
		var label = $("label[for='" + $(data[0]['dwfrm_emailsignup_tastingclub']).attr('id') + "']");
		if (preferences === '') {
			preferences =  label.text().trim();
		} else {
			preferences += ' | ' + label.text().trim();
		}
	}

	if ($(data[0]['dwfrm_emailsignup_hotel']).prop('checked')) {
		var label = $("label[for='" + $(data[0]['dwfrm_emailsignup_hotel']).attr('id') + "']");
		if (preferences === '') {
			preferences =  label.text().trim();
		} else {
			preferences += ' | ' + label.text().trim();
		}
	}
	return preferences;
}

function getContactSettings() {
	var preferences = '';

	if ($('#dwfrm_multishipping_editAddress_userInfo_customer_contactPreferencesCatalogue').prop('checked')) {
		var label = $("label[for='" + $('#dwfrm_multishipping_editAddress_userInfo_customer_contactPreferencesCatalogue').attr('id') + "']");
		if (preferences === '') {
			preferences =  label.text().trim();
		} else {
			preferences += ' | ' + label.text().trim();
		}
	}

	if ($('#dwfrm_multishipping_editAddress_userInfo_customer_contactPreferencesAllowMail').prop('checked')) {
		var label = $("label[for='" + $('#dwfrm_multishipping_editAddress_userInfo_customer_contactPreferencesAllowMail').attr('id') + "']");
		if (preferences === '') {
			preferences =  label.text().trim();
		} else {
			preferences += ' | ' + label.text().trim();
		}
	}

	if ($('#dwfrm_multishipping_editAddress_userInfo_customer_contactPreferencesAllowSMS').prop('checked')) {
		var label = $("label[for='" + $('#dwfrm_multishipping_editAddress_userInfo_customer_contactPreferencesAllowSMS').attr('id') + "']");
		if (preferences === '') {
			preferences =  label.text().trim();
		} else {
			preferences += ' | ' + label.text().trim();
		}
	}
	return preferences;
}

module.exports = emailsignup
/* jshint ignore:end */
